exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".checkbox-wrapper[data-v-21cb7d1a]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.checkbox-wrapper label[data-v-21cb7d1a]{padding-right:8px;margin-bottom:0;cursor:pointer}.checkbox-wrapper input[data-v-21cb7d1a]{margin-top:0;cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-21cb7d1a","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/admin-panel/components/inputs/checkbox.vue
// module id = 06YR
// module chunks = 0